module.exports = __webpack_public_path__ + "img/dome.43f832e3.png";